let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ar2eD")).then(() => parcelRequire('hquq4'));